import { HiOutlineHome, HiUserGroup, HiLink } from "react-icons/hi";
import { TbLayoutGridAdd } from "react-icons/tb";
import { FiSettings, FiShoppingCart } from "react-icons/fi";
import { BiHelpCircle, BiPhone, BiSolidMemoryCard } from "react-icons/bi";
import {
  AiOutlineBook,
  AiFillMessage,
  AiOutlineStar,
  AiOutlineDollar,
  AiOutlineDatabase,
} from "react-icons/ai";
import {
  BsLightningChargeFill,
  BsPerson,
  BsPlayCircle,
} from "react-icons/bs";
import { FaIdCard, FaMoneyBillAlt } from "react-icons/fa";
import { FaWpforms } from "react-icons/fa6";
import {
  MdPriceChange,
  MdContactMail,
  MdOutlineNotifications,
  MdOutlineEmail,
  MdOutlineQrCode2,
  MdOutlineDiscount,
  MdOutlineSmsFailed,
} from "react-icons/md";
import { SiCashapp } from "react-icons/si";
import { RiUploadCloudFill, RiCoupon3Line } from "react-icons/ri";
import { CgQr } from "react-icons/cg";
import { LiaCrownSolid } from "react-icons/lia";
import { GoGraph } from "react-icons/go";
import { IoMdMedical } from "react-icons/io";
import { HiOutlineShoppingBag } from "react-icons/hi2";
import { VscFeedback } from "react-icons/vsc";
import { ReactComponent as AnalyticsIcon } from "../../assets/images/sidebar_icons/analytics.svg";
import { ReactComponent as FunctionIcon } from "../../assets/images/sidebar_icons/function.svg";
import { ReactComponent as ConnectionIcon } from "../../assets/images/sidebar_icons/connection.svg";
import { ReactComponent as DiscountIcon } from "../../assets/images/sidebar_icons/discount.svg";
import { ReactComponent as ShopIcon } from "../../assets/images/sidebar_icons/shop.svg";
import { ReactComponent as PackageIcon } from "../../assets/images/sidebar_icons/package.svg";
import { ReactComponent as QRIcon } from "../../assets/images/sidebar_icons/qr-code.svg";
import { ReactComponent as SettingIcon } from "../../assets/images/sidebar_icons/settings.svg";
import { ReactComponent as HelpIcon } from "../../assets/images/sidebar_icons/help.svg";
import { ReactComponent as LeadIcon } from "../../assets/images/sidebar_icons/lead.svg";

const routes = [
  // {
  //   id: 1,
  //   level: 1,
  //   text: "Home",
  //   icon: <HiOutlineHome />,
  //   path: "/",
  // },
  {
    id: 7,
    level: 1,
    text: "Analytics",
    icon: <AnalyticsIcon />,
    path: "/stats",
    intro: `
  <h3 className="text-lg font-semibold">Gain Insights with Analytics</h3>
  <p className="text-sm text-gray-600">Track user engagement, performance, and trends to make data-driven decisions that grow your business.</p>
`,
  },
  {
    id: 1,
    level: 1,
    text: "Functions",
    icon: <FunctionIcon />,
    path: "/",
    intro: `
      <h3 className="text-lg font-semibold">Start Building Your Digital Experience</h3>
      <p className="text-sm text-gray-600">Create and link Business Card, Payments Links and more. You get one free function for life! Upgrade to unlock additional features and customization options!</p>
    `,
  },
  {
    id: 2,
    level: 1,
    text: "Connections",
    icon: <ConnectionIcon />,
    path: "/contacts",
    intro: `
      <h3 className="text-lg font-semibold">Stay Organized With Ease!</h3>
      <p className="text-sm text-gray-600">View and track your connections all in one place. Use our build-in CRM to keep everything organized and easily follow up with contacts.</p>
    `,
  },
  {
    id: 9,
    level: 1,
    text: "Lead",
    icon: <LeadIcon />,
    path: "/leads",
    intro: `
  <h3 className="text-lg font-semibold">Capture and Manage Leads</h3>
  <p className="text-sm text-gray-600">Monitor incoming leads and follow up effectively. Keep your sales pipeline organized and up to date.</p>
`,
  },
  {
    id: 6,
    level: 1,
    text: "Packages",
    icon: <PackageIcon />,
    path: "/packages",
    intro: `
  <h3 className="text-lg font-semibold">Explore Subscription Packages</h3>
  <p className="text-sm text-gray-600">Choose a package that fits your needs. Unlock advanced features and scale as your business grows.</p>
`,
  },
  // {
  //   id: 3,
  //   level: 1,
  //   text: "Function",
  //   icon: <TbLayoutGridAdd style={{ color: "#22A081" }} />,
  //   path: "/function",
  // },
  {
    id: 4,
    level: 1,
    text: "Shopping",
    icon: <ShopIcon />,
    //path: "https://contactwearables.com/shop/",
    path: "https://contactco.com/collections/all-products",
    intro: `
  <h3 className="text-lg font-semibold">Shop Our Products</h3>
  <p className="text-sm text-gray-600">Browse and purchase our curated collection of smart products and accessories to enhance your digital presence.</p>
`,
  },
  {
    id: 8,
    level: 1,
    text: "QR Code",
    icon: <QRIcon />,
    path: "/qrcode",
    intro: `
  <h3 className="text-lg font-semibold">Smart QR Code Sharing</h3>
  <p className="text-sm text-gray-600">Generate QR codes for instant access to your digital card, payment links, and more.</p>
`,
  },
  {
    id: 10,
    level: 1,
    text: "Product Discount",
    icon: <DiscountIcon />,
    path: "/discountedProduct",
    intro: `
  <h3 className="text-lg font-semibold">See Product Discounts</h3>
  <p className="text-sm text-gray-600">Offer limited-time deals and promotions.</p>
`,
  },
  // {
  //   id: 11,
  //   level: 1,
  //   text: "Smart Profile",
  //   icon: <BsLightningChargeFill />,
  //   path: "/smart-profile",
  //   intro: `
  // <h3 className="text-lg font-semibold">Automate Your Profiles</h3>
  // <p className="text-sm text-gray-600">Switch profiles automatically using schedules and saved locations.</p>
  // `,
  // },
  {
    id: 5,
    level: 1,
    text: "Settings",
    icon: <SettingIcon />,
    path: "/settings",
    intro: `
  <h3 className="text-lg font-semibold">Customize Your Experience</h3>
  <p className="text-sm text-gray-600">Manage your account preferences, privacy settings, and app configurations to tailor the platform to your needs.</p>
`,
  },
  // {
  //   level: 1,
  //   text: "Pages",
  //   icon: <AiOutlineBook />,
  //   // path: "/settings/pages",
  //   path: "/pages",
  // },
  // {
  //   level: 1,
  //   text: "Users",
  //   icon: <BsPerson />,
  //   // path: "/settings/pages",
  //   path: "/users",
  // },
  // {
  //   level: 1,
  //   text: "Pricing",
  //   icon: <AiOutlineBook />,
  //   path: "/pricing",
  // },
  // {
  //   level: 1,
  //   text: "Tutorial",
  //   icon: <AiOutlineBook />,
  //   path: "/tutorial",
  // },
];

const otherRoutes = [
  {
    id: 50,
    level: 1,
    text: "Help",
    icon: <HelpIcon />,
    path: "/help",
  },
];

const teamOwnerRoutes = [
  // {
  //   id: 1,
  //   level: 1,
  //   text: "Location",
  //   icon: <ImLocation2 />,
  //   path: "/location",
  // },
  // {
  //   id: 2,
  //   level: 1,
  //   text: "Department",
  //   icon: <ImOffice />,
  //   path: "/department",
  // },
  {
    id: 1,
    level: 1,
    text: "Team",
    icon: <HiUserGroup />,
    path: "/team",
  },
  {
    id: 2,
    level: 1,
    text: "Invitations",
    icon: <MdOutlineEmail />,
    path: "/invitations",
  },

  {
    id: 3,
    level: 1,
    text: "Connections",
    icon: <BsPerson />,
    path: `/contacts`,
  },
  {
    id: 4,
    level: 1,
    text: "Function",
    icon: <TbLayoutGridAdd />,
    path: "/function",
  },
  {
    id: 5,
    level: 1,
    text: "Subscription",
    icon: <MdPriceChange />,
    path: "/viewSubscription",
  },
  {
    id: 6,
    level: 1,
    text: "Settings",
    icon: <FiSettings />,
    path: "/settings",
  },
  {
    id: 7,
    level: 1,
    text: "Pending Payments",
    icon: <FaMoneyBillAlt />,
    path: "/pendingPayments",
  },
  {
    id: 8,
    level: 1,
    text: "QR Code",
    icon: <CgQr />,
    path: "/qrcode",
  },
  {
    id: 9,
    level: 1,
    text: "Lead",
    icon: <LiaCrownSolid />,
    path: "/leads",
  },
  {
    id: 10,
    level: 1,
    text: "Product Discount",
    icon: <RiCoupon3Line />,
    path: "/discountedProduct",
  },
  // {
  //   id: 11,
  //   level: 1,
  //   text: "Smart Profile",
  //   icon: <BsLightningChargeFill />,
  //   path: "/smart-profile",
  // },
];

const adminRoutes = [
  {
    id: 1,
    level: 1,
    text: "Function",
    icon: <TbLayoutGridAdd />,

    childrens: [
      {
        id: 1,
        text: "Cards",
        icon: <FaIdCard />,
        path: "/cards",
      },
      {
        id: 2,
        text: "Custom URL'S",
        icon: <HiLink />,
        path: "/customUrls",
      },
      {
        id: 3,
        text: "File Upload",
        icon: <RiUploadCloudFill />,
        path: "/fileUpload",
      },
      {
        id: 4,
        text: "Payment Services",
        icon: <SiCashapp />,
        path: "/payments",
      },
      // {
      //   id: 11,
      //   text: "Venmo",
      //   icon: <IoLogoVenmo />,
      //   path: "/venmos",
      // },
      {
        id: 5,
        text: "Emergency",
        icon: <MdContactMail />,
        path: "/emergenctContacts",
      },
      {
        id: 6,
        text: "Memory",
        icon: <BiSolidMemoryCard />,
        path: "/memory",
      },
      {
        id: 7,
        text: "Lead Builder",
        icon: <FaWpforms />,
        path: "/formBuilder",
      },
      {
        id: 8,
        text: "Medical ID",
        icon: <IoMdMedical />,
        path: "/medicalId",
      },
    ],
  },
  {
    id: 2,
    level: 1,
    text: "Help",
    icon: <BiHelpCircle />,

    childrens: [
      {
        id: 1,
        level: 1,
        text: "Tutorial",
        icon: <BsPlayCircle />,
        path: "/tutorial",
      },
      {
        id: 2,
        level: 1,
        text: "FAQ's",
        icon: <AiFillMessage />,
        path: "/faqs",
      },
      {
        id: 3,
        level: 1,
        text: "Contact Us",
        icon: <BiPhone />,
        path: "/contactUs",
      },
    ],
  },
  {
    id: 3,
    level: 1,
    text: "Admin Users",
    icon: <HiUserGroup />,
    path: "/adminUser",
  },
  {
    id: 4,
    level: 1,
    text: "Pages",
    icon: <AiOutlineBook />,
    path: "/pages",
  },
  {
    id: 5,
    level: 1,
    text: "Users",
    icon: <BsPerson />,
    path: "/users",
  },
  {
    id: 6,
    level: 1,
    text: "Team Owners",
    icon: <HiUserGroup />,
    path: "/allTeamOwners",
  },

  {
    id: 7,
    level: 1,
    text: "Package Inquiry",
    icon: <AiOutlineBook />,
    path: "/packageContacts",
  },
  {
    id: 8,
    level: 1,
    text: "Send Notification",
    icon: <MdOutlineNotifications />,
    path: "/notificationListing",
  },
  {
    id: 9,
    level: 1,
    text: "App Setting",
    icon: <FiSettings />,
    path: "/appSetting",
  },
  {
    id: 10,
    level: 1,
    //text: "Manage Subscriptions",
    text: "Create Package",
    icon: <AiOutlineDollar />,
    path: "/manageSubscriptions",
  },
  {
    id: 11,
    level: 1,
    text: "Active Subscriptions",
    icon: <AiOutlineDollar />,
    path: "/activeSubscriptions",
  },
  {
    id: 12,
    level: 1,
    text: "Coupon Management",
    icon: <RiCoupon3Line />,
    path: "/coupons",
  },
  {
    id: 13,
    level: 1,
    text: "Generate QR Code",
    icon: <MdOutlineQrCode2 />,
    path: "/generateQRCode",
  },
  {
    id: 14,
    level: 1,
    text: "Product Discount",
    icon: <MdOutlineDiscount />,
    path: "/productDiscount",
  },
  {
    id: 15,
    level: 1,
    text: "Product Discount Link",
    icon: <MdOutlineDiscount />,
    path: "/productDiscountLink",
  },
  {
    id: 16,
    level: 1,
    text: "Customer Feedback",
    icon: <VscFeedback />,
    path: "/customerFeedback",
  },
  {
    id: 17,
    level: 1,
    text: "NFC Failure",
    icon: <MdOutlineSmsFailed />,
    path: "/nfcFailure",
  },
  // {
  //   id: 16,
  //   level: 1,
  //   text: "Chatbot Knowledge Base",
  //   icon: <AiOutlineDatabase />,
  //   path: "/chatbotKnowledgeBase",
  // },
  // {
  //   id: 12,
  //   level: 1,
  //   text: "QR Code Management",
  //   icon: <CgQr />,
  //   path: "/qrCodeManagement",
  // },
  // {
  //   level: 1,
  //   text: "Tutorial",
  //   icon: <BsPlayCircle />,
  //   path: "/tutorial",
  // },
  // {
  //   level: 1,
  //   text: "FAQ's",
  //   icon: <AiFillMessage />,
  //   path: "/faqs",
  // },
  // {
  //   level: 1,
  //   text: "Contact Us",
  //   icon: <BiPhone />,
  //   path: "/contactUs",
  // },
];

const teamAdminRoutes = [
  {
    id: 1,
    level: 1,
    text: "Home",
    icon: <HiOutlineHome />,
    path: "/",
  },
  {
    id: 2,
    level: 1,
    text: "Team",
    icon: <HiUserGroup />,
    path: "/team",
  },
  {
    id: 3,
    level: 1,
    text: "Invitations",
    icon: <MdOutlineEmail />,
    path: "/invitations",
  },
  {
    id: 4,
    level: 1,
    text: "Connections",
    icon: <BsPerson />,
    path: `/contacts`,
  },
  {
    id: 5,
    level: 1,
    text: "Function",
    icon: <TbLayoutGridAdd />,
    path: "/function",
  },
  {
    id: 6,
    level: 1,
    text: "Shop",
    icon: <FiShoppingCart />,
    //path: "https://contactwearables.com/shop/",
    path: "https://contactco.com/collections/all-products",
  },
  {
    id: 7,
    level: 1,
    text: "Settings",
    icon: <FiSettings />,
    path: "/settings",
  },
  {
    id: 8,
    level: 1,
    text: "Pending Payments",
    icon: <FaMoneyBillAlt />,
    path: "/pendingPayments",
  },
];

export { routes, otherRoutes, teamOwnerRoutes, adminRoutes, teamAdminRoutes };